import Auth from 'dashboard/api/auth';

export const buildAuthHeaders = (headers = {}) => {
  if (!Auth.hasAuthCookie()) {
    return headers;
  }

  const authData = Auth.getAuthData();

  return {
    ...headers,
    'access-token': authData['access-token'],
    'token-type': authData['token-type'],
    client: authData.client,
    expiry: authData.expiry,
    uid: authData.uid,
  };
};

export const authenticatedFetch = (url, options = {}) => {
  return fetch(url, {
    credentials: 'same-origin',
    ...options,
    headers: buildAuthHeaders(options.headers),
  });
};
